import { UserNotificationSettings } from "@supernova-studio/model";
import { z } from "zod";

export const DTOUpdateUserNotificationSettingsPayload = z.object({
    notificationSettings: UserNotificationSettings,
});

export type DTOUpdateUserNotificationSettingsPayload = z.infer<typeof DTOUpdateUserNotificationSettingsPayload>;


export const DTOUserNotificationSettingsResponse = z.object({
    userId: z.string(),
    workspaceId: z.string(),
    notificationSettings: UserNotificationSettings,
});

export type DTOUserNotificationSettingsResponse = z.infer<typeof DTOUserNotificationSettingsResponse>;
